import { createSlice } from '@reduxjs/toolkit';
import { MatchingState } from '@business/interfaces/match';
import type { RootState } from './store';

const initialState: MatchingState = {
  id: '',
  returnToMatch: ''
};

export const matchStateSlice = createSlice({
  name: 'matchStateSlice',
  initialState,
  reducers: {
    setMatchId: (state, action) => {
      state.id = action.payload.id;
    },
    resetMatchId: () => {
      return initialState;
    },
    setReturnToMatch: (state, action) => {
      state.returnToMatch = action.payload.returnToMatch;
    }
  }
});

export const { setMatchId, resetMatchId, setReturnToMatch } =
  matchStateSlice.actions;
export const getMatchId = (state: RootState) => state.matchStateSlice.id;
export const getReturnToMatch = (state: RootState) =>
  state.matchStateSlice.returnToMatch;
